import { KYMW2500Model } from '../kymw2500.model';
import { GetPageCopyModel } from '../vo/get-page-copy.model';
import { Injectable } from "@angular/core";
import { PlessHttp } from '../../../../shared/http/pless-http.service';
import { PlessDialogServiceSub } from '../../../../commons/kymw00/pless-dialog-service-sub';
import { PlessRequest } from 'src/app/shared/vo/pless-request.model';
import { PlessJsonResponderSub } from 'src/app/commons/kymw00/pless-json-responder-sub.service';

/**
 * ページネーション設定一覧取得コマンド
 * サーバーにページネーション設定一覧情報をリクエストし、結果を表示する。
 *
 * @export GetPageCopyService
 * @class GetPageCopyService
 * @extends {PlessJsonResponderSub}
 */
@Injectable()
export class GetPageCopyService extends PlessJsonResponderSub<any> {
  private model: KYMW2500Model = null;
  private vo: GetPageCopyModel = null;

  constructor(
    protected plessHttp: PlessHttp,
    protected dialogService: PlessDialogServiceSub
  ) {
    super(plessHttp, dialogService);
  }

  /**
   * bodyにセットする値を返す
   *
   * @private
   * @returns {PlessRequest} リクエストJSON
   * @memberof GetPageCopyService
   */
  private getBody(): PlessRequest {
    return new PlessRequest({
      parameter: {
        MediumType: this.vo.MediumType,
        OrderCodeFrom: this.vo.OrderCodeFrom,
        OrderCodeTo: this.vo.OrderCodeTo
      }
    });
  }

  /**
   * API呼び出し
   *
   * @param {KYMW2500Model} model モデルクラス
   * @param {GetPageCopyModel} vo ページネーション設定一覧取得条件VO
   * @memberof GetPageCopyService
   */
  execute(model: KYMW2500Model, vo: GetPageCopyModel) {
    this.model = model;
    this.vo = vo;
    this.send('getPageCopy', this.getBody());
  }

  /**
   * API通信成功時の処理
   *
   * @param {*} data レスポンスデータ
   * @memberof GetPageCopyService
   */
  success(data: any) {
    // ページネーション選択エリアのボタンを非活性化する
    this.model.kymw2500Component.disablePagenationListButton();
    // ページネーション詳細エリアを非活性化する
    this.model.kymw2500Component.disablePagenationDetail();
    // データグリッド「ページネーション一覧設定」を更新
    this.model.updatePagenationList(data, this.vo);
    // ページネーション詳細エリアをクリア
    this.model.kymw2500Component.clearPagenationDetail();
  }
}
